module.exports = __webpack_public_path__ + "img/click.3c3c1d03.png";